import { SYSTEM_CODE_NUMBERS } from './types';

export const SYSTEM_CODES: Record<SYSTEM_CODE_NUMBERS, string> = {
  '1': 'has no spaces',
  '8': 'contains at least 16 characters',
  '3': 'contains at least 1 digit',
  '4': 'contains at least one capital letter',
  '5': 'contains at least one lowercase letter',
  '9': 'contains at least one symbol',
};
